import { screenSizes } from '@lux/tokens';
const getWindowWidth = () => typeof window !== 'undefined' &&
    (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);
export const isMobile = () => getWindowWidth() < screenSizes.sm;
//# sourceMappingURL=screenSize.js.map